import { render, staticRenderFns } from "./game-preview-item.vue?vue&type=template&id=2c3e0296&scoped=true"
import script from "./game-preview-item.vue?vue&type=script&lang=js"
export * from "./game-preview-item.vue?vue&type=script&lang=js"
import style0 from "./game-preview-item.vue?vue&type=style&index=0&id=2c3e0296&prod&scoped=true&lang=scss"
import style1 from "./game-preview-item.vue?vue&type=style&index=1&id=2c3e0296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e0296",
  null
  
)

export default component.exports